import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a4d7bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MensagemDeErro__Mensagem" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-times-circle MensagemDeErro__Icone" }, null, -1))
const _hoisted_3 = { class: "MensagemDeErro__Texto" }

interface Props {
    mensagem: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AMensagemDeErro',
  props: {
    mensagem: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.mensagem), 1)
  ]))
}
}

})